module.exports = __webpack_public_path__ + "static/media/crofton-house-school.822a86f1.jpg";